import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Image, Wrench, MessageSquare, ArrowRight } from "lucide-react";
import { api } from "../../services/api";

const CARDS = [
    { key: "referencie",   label: "Referencie",  icon: Image,         to: "/admin/referencie",   color: "text-nova-cyan",   bg: "bg-nova-cyan/8"  },
    { key: "technika",     label: "Technika",    icon: Wrench,        to: "/admin/technika",     color: "text-emerald-400", bg: "bg-emerald-400/8"},
    { key: "testimonials", label: "Hodnotenia",  icon: MessageSquare, to: "/admin/testimonials", color: "text-violet-400",  bg: "bg-violet-400/8" },
];

export default function AdminDashboard() {
    const [stats, setStats] = useState(null);

    useEffect(() => {
        api.stats().then(setStats).catch(() => {});
    }, []);

    return (
        <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-nova-cyan mb-3">/ Dashboard</div>
            <h1 className="font-heading text-2xl font-black tracking-tight mb-8">Prehľad obsahu</h1>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                {CARDS.map(({ key, label, icon: Icon, to, color, bg }) => (
                    <Link
                        key={key}
                        to={to}
                        className="border border-white/8 bg-nova-surface/40 rounded-xl p-6 hover:border-white/20 transition-colors group"
                    >
                        <div className={`w-10 h-10 rounded-md ${bg} flex items-center justify-center mb-4`}>
                            <Icon className={`w-5 h-5 ${color}`} />
                        </div>
                        <div className="font-heading text-3xl font-black text-white mb-1">
                            {stats ? stats[key] : "—"}
                        </div>
                        <div className="text-zinc-500 text-sm font-medium flex items-center gap-1.5">
                            {label}
                            <ArrowRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}
